import { render, staticRenderFns } from "./consultation-list.vue?vue&type=template&id=c6e8d79a&scoped=true&"
import script from "./consultation-list.vue?vue&type=script&lang=js&"
export * from "./consultation-list.vue?vue&type=script&lang=js&"
import style0 from "./consultation-list.vue?vue&type=style&index=0&id=c6e8d79a&prod&lang=less&"
import style1 from "./consultation-list.vue?vue&type=style&index=1&id=c6e8d79a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e8d79a",
  null
  
)

export default component.exports